import { RenderModeEnum } from "../typings/spec/common";

import { isMiniAppLikeMode, isMobileLikeMode } from "../util";

export function getDefaultInteractionConfigByMode(mode) {
    return mode === RenderModeEnum["desktop-browser"] || mode === RenderModeEnum["desktop-miniApp"] ? {
        hover: {
            enable: !0,
            trigger: "pointermove",
            triggerOff: "view:pointerleave"
        },
        select: {
            enable: !0,
            trigger: "pointertap"
        }
    } : isMobileLikeMode(mode) || isMiniAppLikeMode(mode) ? {
        hover: {
            enable: !0,
            trigger: [ "pointerdown", "pointermove" ],
            triggerOff: "view:pointerleave"
        },
        select: {
            enable: !0,
            trigger: "tap"
        }
    } : null;
}
//# sourceMappingURL=config.js.map